import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import Router from "./router/Router";
import { preAuth, preAuthCPR, preAuthFAF } from "./stores/slices/preAuthSlice";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Loader from "./components/menu/Loader";
import SmartyStreetModal from "./components/modal/SmartyStreetModal";
import generalConfigSlice from "./stores/slices/generalConfiguration/generalConfigSlice";
import { isLoader, jwt_CPR, jwt_FAF, jwt_PPP, jwtToken_PPP, PARTNER_AUTH, PARTNER_BROWSER_ID } from "./constant/Constants";
import ModalComponent from "./components/modal/ModalComponent";
import sessionManagement, {
  exit,
  extend,
  resetSessionTiming,
} from "./utilities/sessionManagement";
import { Modal } from "antd";
import { useNavigate } from "react-router";
import { resetLogin } from "./stores/slices/loginSlice";
import { clearInterval, setInterval } from 'worker-timers'
import { fetchExtendSession } from "./stores/slices/generalConfiguration/sessionExtendSlice";
import { fetchLogOut } from "./stores/slices/generalConfiguration/logOutSlice";
import { resetSmartySteert } from "./stores/slices/smartyStreetSlice";
import { resetRequiredActions } from "./stores/slices/requiredActionsSlice";
import { getAllSessions, getJwtToken, getOAuthToken, getRegistrationTokenCPR, getRegistrationTokenFAF, getRegistrationTokenPPP } from "./utilities/API/supertokenServices";
import { jwtTokenService } from "./stores/slices/supertokens/jwtTokenSlice";
import { resetTermsOfUsePopup } from "./stores/slices/supertokens/metaDataSlice";
import { fetchLookUp } from "./stores/slices/lookupSlice";
import { generateBrowserID } from "./utilities/API/PreAuth/preAuth";
// import { getRegistrationToken } from "./utilities/API/supertokenServices";
import Session from "supertokens-web-js/recipe/session";
import { fetchMessages } from "./stores/slices/portalMessagesSlice";
import { getCPRTokenService, getFAFTokenService, getTokenService } from "./stores/slices/getTokenSlice";
import { oAuthCMDetails } from "./stores/slices/caseManagement/oAuthCMSlice";
import { iframe } from "./container/iFrame";
// import { caseLogOut } from "./utilities/API/caseServices";

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ResourceDirectoryLoader = useSelector(
    (state) => state.financialResourceDirectorySlice.getResourceData.loader
  );
  const smartyStreetDetails = useSelector((state) => state.smartyStreetSlice);
  let smartyStreetData = smartyStreetDetails?.smartyStreetData?.responseDetails;
  const isLoader = useSelector((state) => state.einSlice).registerData?.loader;
  const isSendEmailLoader = useSelector((state) => state.emailSendSlice)
  const isLoggedin = useSelector((state) => state.loginSlice.isLoggedin)
  const loginData = useSelector((state) => state.loginSlice)
  const sessionData = useSelector((state) => state.allServiceSlice.sessionValue)
  const Email = useSelector((state) => state.loginSlice.Email)
  const generalConfig = useSelector((state) => state.generalConfigSlice)
  const BrowserId = useSelector(state => state.preAuthSlice.browserToken)
  const portalUserID = useSelector(state => state.loginSlice.value.PortalUserID)

  const [modalOpen, setModalOpen] = useState(false);

  const [extendSession, setExtendSession] = useState(false)
  const [logoutSession, setLogoutSession] = useState(false)
  const [sessionExtendAPI, setSessioExtendAPI] = useState(false)
  const [autoExit, setAutoExit] = useState(false)

  const checkIfSessionIsActive = async () => {
    // const getSession = await getAllSessions(loginData.userID,sessionData,"isActiveSession", loginData.rememberMeFlag);
    setSessioExtendAPI(false)
    await getJwtToken(loginData.value.EmailAddress, "PPP", async (response) => {
      await getOAuthToken(response.jwt, "PPP");
    })
  }

  const checkActiveSession = (session) => {
    if (session[0] != sessionData.sessionID) {
      toast.error('Session Expired!')
      setTimeout(() => {
        //  window.location.assign(window.location.origin);
        navigate("/");
      }, 2000);
    }
  }

  const partnerTokenCallback =  (response) => {
    if(response?.response?.data?.statusCode == "401"){
      navigate("/Kill");
      // getPartnerToken()
    }
  }

  const getPartnerToken = async () => {
      await getRegistrationTokenPPP(partnerTokenCallback);
  }


  useEffect(() => {
    resetSessionTiming()
    isLoggedin && sessionManagement(setExtendSession, setLogoutSession, setInterval, clearInterval, setSessioExtendAPI, loginData.value.EmailAddress, checkIfSessionIsActive, setAutoExit, loginData?.rememberMeFlag)
    setInterval(() => {
      if (isLoggedin) {
        // checkIfSessionIsActive();   
        getJwtToken(Email.trim(), 'CPR');
        // getOAuthToken(jwt_CPR.token,"CPR");
        getJwtToken(Email.trim(), 'FAF');
        // getOAuthToken(jwt_FAF.token,"FAF");
        getJwtToken(Email.trim(), 'PPP')
        getOAuthToken(jwt_PPP.token, "PPP");
      } else {
        getRegistrationTokenFAF();
        getPartnerToken();
        getRegistrationTokenCPR();
      }
    }, 1800000);
  }, [isLoggedin])

  useEffect(async () => {
    dispatch(getTokenService())
    dispatch(getCPRTokenService())
    dispatch(getFAFTokenService())
    dispatch(oAuthCMDetails())
    await getRegistrationTokenFAF();
    await getPartnerToken();
    await getRegistrationTokenCPR();
    dispatch(fetchLookUp('FAF'))
    dispatch(fetchLookUp("CPR"));
    dispatch(fetchMessages())
  }, [])

  const logoutFun = async () => {
    loginData?.rememberMeFlag != true && await Session.signOut();
    dispatch(resetLogin());
    dispatch(resetSmartySteert());
    dispatch(resetRequiredActions())
    setLogoutSession(false);
    // dispatch(fetchLogOut({ BrowserId:PARTNER_BROWSER_ID.ID, portalUserID },logoutResponse))
    if (autoExit) {
      toast.error("Session Expired")
      setAutoExit(false)
    } else {
      toast.success("LogOut Successful")
    }
    iframe()
    navigate("/");
    // caseLogOut(loginData?.CaseMgtUserID)
  }
  
  if (isLoggedin && logoutSession) {
    logoutFun()
  }

  useEffect(() => {
    generateBrowserID()
  }, [])

  useEffect(() => {
    // ComponentDidMount logic
    // loginData.rememberMeFlag != "true" && deleteAllCookies();
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);

    return () => {
      // ComponentWillUnmount logic
      toast.dismiss();
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
    };
  }, []);
  const handleBeforeUnload = (event) => {
    if (isLoggedin) {
      const message = "Are you sure you want to refresh the page? Unsaved data might be lost.";
      // This event is triggered when the user is about to close the tab
      event.preventDefault();  // Modern browsers require this for the prompt
      event.returnValue = message;  // The default confirmation dialog (optional in newer browsers)
      return message
    }
  };
  const handleUnload = () => {
    // This event is triggered when the page is being unloaded
    // You can add additional cleanup logic here, such as saving unsaved data
  };
  const deleteAllCookies = () => {
    document.cookie.split(';').forEach(cookie => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    });
  }
  if (sessionExtendAPI) {
    dispatch(fetchExtendSession({ BrowserId: PARTNER_BROWSER_ID.ID, portalUserID }))
    setSessioExtendAPI(false)
  }
  const logoutResponse = (res) => {
    dispatch(resetTermsOfUsePopup(true))
    if (res.ResponseDetails.ResponseCode == "010") {
      getPartnerToken();
    }
  }
  return (
    <>
      <div className="main">
        <Router />
        <ToastContainer role="alert" autoClose={20000} />
      </div>
      <ModalComponent targetRootId="root-portal">
        {smartyStreetData?.ss_toggle ? (
          <SmartyStreetModal setModalOpen={setModalOpen} />
        ) : null}
      </ModalComponent>
      {/* loader  not yet completed !!! */}
      {isLoader || ResourceDirectoryLoader || isSendEmailLoader.loader && <Loader />}
      <Modal
        title=""
        open={extendSession}
        onOk={() => {
          toast.success("Session Extended")
          extend(setExtendSession)
        }}
        onCancel={() => exit(setExtendSession, setLogoutSession, clearInterval, loginData.rememberMeFlag)}
        width={800}
        cancelText="Leave"
        maskClosable={false}
        closeIcon={true}
        okText="Extend"
      >
        <React.Fragment>
          <p className="fw-medium fs-base text-center mb-3">
            Session Time Out Warning{" "}
          </p>
          <p>
            In two minutes, your session will time out. Please do one of the
            following:{" "}
          </p>
          <p>Click Extend to extend and return to your session. </p>
          <p>
            Click Leave to log out and discard any work that is in progress.{" "}
          </p>
          <p>
            If no action is taken, you will be logged out in two minutes and
            lose any work that is in progress.{" "}
          </p>
        </React.Fragment>
      </Modal>
    </>
  );
}

export default App;
